import { on } from 'delegated-events'

const header = document.querySelector('.site-header')
const pageHeader = document.querySelector('.page-header')

export default {
  can: () => header,
  run: () => {
    on('click', '.site-mobile-menu-toggle', () => {
      document.documentElement.classList.toggle('js-menu-active')
    })

    window.addEventListener('scroll', () => {
      if (window.scrollY > 24) {
        header.classList.add('is-stuck')
      } else {
        header.classList.remove('is-stuck')
      }
    })

    if (pageHeader) {
      const observer = new IntersectionObserver((entries) => {
        const el = entries[0]

        if (el.isIntersecting) {
          header.classList.remove('has-scrolled-past-page-header')
        } else {
          header.classList.add('has-scrolled-past-page-header')
        }
      }, {})

      observer.observe(pageHeader)
    }
  },
}
